import React from 'react';
import { createRoot } from 'react-dom/client'; // React 18+ createRoot API
import App from './App';
import { CalculatorProvider } from './context/CalculatorContext';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import './styles.css';

// Grab the div with id="root"
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CalculatorProvider>
        <App />
      </CalculatorProvider>
    </ThemeProvider>
  </React.StrictMode>
);
